import '../styles/GlobalDesign.css';
import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : process.env.REACT_APP_API_URL || '/api';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [loading, setLoading] = useState(true);
  const [verifying, setVerifying] = useState(true);
  const [tokenValid, setTokenValid] = useState(false);
  const [reseller, setReseller] = useState(null);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });

  useEffect(() => {
    if (!token) {
      setError('Token manquant');
      setVerifying(false);
      setLoading(false);
      return;
    }

    verifyToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  const verifyToken = async () => {
    try {
      const response = await axios.post(`${API_URL}/password-reset/verify-token`, { token });
      
      if (response.data.success && response.data.valid) {
        setTokenValid(true);
        setReseller({
          email: response.data.email,
          nom: response.data.nom
        });
      } else {
        setError(response.data.error || 'Token invalide ou expiré');
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la vérification du token');
    } finally {
      setVerifying(false);
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Les mots de passe ne correspondent pas');
      return;
    }

    if (formData.password.length < 6) {
      setError('Le mot de passe doit contenir au moins 6 caractères');
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`${API_URL}/password-reset/reset`, {
        token,
        new_password: formData.password
      });

      if (response.data.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/reseller/login');
        }, 3000);
      }
    } catch (err) {
      setError(err.response?.data?.error || 'Erreur lors de la réinitialisation');
    } finally {
      setLoading(false);
    }
  };

  if (verifying) {
    return (
      <div className="auth-bg-overlay">
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }} className="pulse-anim">⏳</div>
          <p className="text-muted" style={{ fontSize: '1.1rem' }}>Vérification du lien...</p>
        </div>
      </div>
    );
  }

  if (!tokenValid) {
    return (
      <div className="auth-bg-overlay">
        <nav className="new-design-navbar" style={{ position: 'fixed', top: 0 }}>
          <div className="new-design-container">
            <Link to="/" className="new-design-logo">
              <img src="/logo.png" alt="Fluxivo" className="new-design-logo-img" style={{height: '36px', width: 'auto'}} />
              <span className="new-design-logo-text">Flux<span>ivo</span></span>
            </Link>
          </div>
        </nav>
        <div className="auth-page-container" style={{ maxWidth: '500px', textAlign: 'center', marginTop: '80px' }}>
          <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>❌</div>
          <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }} className="text-white">Lien invalide</h2>
          <p className="text-muted" style={{ marginBottom: '1rem' }}>{error || 'Le lien de réinitialisation est invalide ou a expiré.'}</p>
          <div className="error-box">
            <p style={{ margin: 0 }}>
              ⏰ Les liens de réinitialisation expirent après 1 heure.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '1rem', flexDirection: 'column' }}>
            <Link to="/reseller/forgot-password" className="new-design-btn new-design-btn-primary">
              Demander un nouveau lien
            </Link>
            <Link to="/reseller/login" className="new-design-btn new-design-btn-secondary">
              Retour à la connexion
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-bg-overlay">
      <nav className="new-design-navbar" style={{ position: 'fixed', top: 0 }}>
        <div className="new-design-container">
          <Link to="/" className="new-design-logo">
            <img src="/logo.png" alt="Fluxivo" className="new-design-logo-img" style={{height: '36px', width: 'auto'}} />
            <span className="new-design-logo-text">Flux<span>ivo</span></span>
          </Link>
        </div>
      </nav>
      <div className="auth-card">
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <h1 className="auth-page-title">
            🔐 Nouveau mot de passe
          </h1>
          <p className="text-muted" style={{ marginBottom: '1rem' }}>Définissez un nouveau mot de passe pour votre compte</p>
          {reseller && (
            <div className="user-info-box">
              <p><strong>{reseller.nom}</strong></p>
              <p style={{ fontSize: '0.9rem' }}>{reseller.email}</p>
            </div>
          )}
        </div>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '4rem', marginBottom: '1rem' }}>✅</div>
            <h2 style={{ fontSize: '2rem', marginBottom: '1rem' }} className="text-white">Mot de passe réinitialisé !</h2>
            <p className="text-muted" style={{ marginBottom: '1rem' }}>Votre mot de passe a été modifié avec succès.</p>
            <div className="success-box">
              <p style={{ margin: 0 }}>
                Redirection vers la connexion dans 3 secondes...
              </p>
            </div>
            <Link to="/reseller/login" className="new-design-btn new-design-btn-primary w-full">
              Se connecter maintenant →
            </Link>
          </div>
        ) : (
          <>
            {error && <div className="error-box">{error}</div>}

            <form onSubmit={handleSubmit}>
              <div className="new-design-form-group">
                <label>Nouveau mot de passe</label>
                <div className="pwd-input-wrapper">
                  <input
                    type={showPassword ? "text" : "password"}
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                    required
                    placeholder="Minimum 6 caractères"
                    disabled={loading}
                    minLength={6}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    disabled={loading}
                    className="toggle-pwd-btn"
                  >
                    {showPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </div>

              <div className="new-design-form-group">
                <label>Confirmer le mot de passe</label>
                <div className="pwd-input-wrapper">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                    required
                    placeholder="Retapez votre mot de passe"
                    disabled={loading}
                    minLength={6}
                  />
                  <button
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    disabled={loading}
                    className="toggle-pwd-btn"
                  >
                    {showConfirmPassword ? '👁️' : '👁️‍🗨️'}
                  </button>
                </div>
              </div>

              <div className="notice-box" style={{ marginBottom: '1.5rem' }}>
                <p style={{ marginBottom: '0.5rem' }}>Le mot de passe doit contenir :</p>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  <li style={{ color: formData.password.length >= 6 ? 'var(--green-bright)' : 'var(--gray-400)', marginBottom: '0.3rem' }}>
                    ✓ Au moins 6 caractères
                  </li>
                  <li style={{ color: formData.password === formData.confirmPassword && formData.password ? 'var(--green-bright)' : 'var(--gray-400)' }}>
                    ✓ Les deux mots de passe correspondent
                  </li>
                </ul>
              </div>

              <button type="submit" className="new-design-btn new-design-btn-primary w-full" disabled={loading}>
                {loading ? 'Réinitialisation...' : 'Réinitialiser mon mot de passe'}
              </button>
            </form>

            <div className="auth-center-link">
              <Link to="/reseller/login">
                ← Retour à la connexion
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
